<template>
  <div class="box">
    <router-link
      v-for="(item, key) in items"
      :key="`${key}-item`"
      :to="{ path: `/${routePrefix}/${item.slug}` }"
      v-slot="{ navigate }"
      custom
    >
      <div class="box_card" @click="navigate">
        <div
          v-if="useBackgroundImage"
          class="image"
          :style="{ backgroundImage: `url(${item.search_image})` }"
        >
          <div class="image__preview"><p>Click to View</p></div>
        </div>
        <div v-else class="image-box">
          <img class="image" :src="item.search_image" />
          <div class="hover-container">Click to View</div>
        </div>

        <div class="type">{{ item.type }}</div>
        <h3 class="title">{{ item.title }}</h3>
        <span class="data">{{ item.dates }}</span>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    items: Array,
    routePrefix: String,
    useBackgroundImage: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.box {
  @include gridLayoutResponsive;

  &_card {
    @include flexColumnClickable;

    .image {
      position: relative;
      @include imageContainer();
      @media screen and (max-width: $md) {
        height: 40vw;
      }
      @media screen and (max-width: $xs) {
        height: 90vw;
      }

      &__preview {
        @include imagePreview;

        p {
          @include imagePreviewParagraph;
        }
      }

      &:hover {
        .image__preview {
          @include imageHoverEffect;
        }
        .image-box {
          .hover-container {
            opacity: 1;
          }
        }
      }
    }

    .type {
      @include typeBadge;
    }

    .title {
      font-size: 2.4rem;
      line-height: 3.1rem;
      margin-top: 1rem;
    }

    .data {
      margin-top: 1.2rem;
      text-transform: uppercase;
      @media screen and (max-width: $xs) {
        margin-top: 1rem;
        font-size: 1.4rem;
        line-height: 2.5rem;
      }
    }
  }
}
</style>

